T.CorporateContactUs = Class(
	/**
	 * @lends {T.CorporateContactUs#}
	 */
	{
		__construct( par = null ) {
			par = par || {};
			this.node = mkE({
				tag: 'div',
				className: 'corporate-contact-us container',
				els: [
					{
						tag: 'div',
						className: 'bs-row',
						els: [
							{
								tag: 'div',
								className: 'col-12 col-md-6',
								els: [
									{
										tag: 'div',
										className: 'corporate-contacts-title-caption',
										text: D.Lang.get('corporate-form.caption')
									},
									{
										tag: 'h2',
										className: 'h1',
										text: D.Lang.get('corporate-form.title')
									}
								]
							},
							{
								tag: 'div',
								className: 'col-12 col-md-6',
								els: [
									{
										tag: 'div',
										className: 'corporate-contacts-box',
										els: [
											{
												tag: 'div',
												className: 'caption',
												text: D.Lang.get('corporate-form.drop-line')
											},
											{
												tag: 'a',
												href: 'mailto:hello@roadgames.com',
												className: 'mail',
												text: 'hello@roadgames.com'
											},
											!par.fromHome && in_array(D.LANG, ['lv', 'en', 'et']) ? {
												tag: 'a',
												href: 'call:+37129181305',
												className: 'phone',
												text: '+371 29 181 305'
											} : '',
											{
												tag: 'div',
												className: ''
											}
										]
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'bs-row',
						els: [
							{
								tag: 'div',
								className: 'col-12',
								els: [
									new T.CorporateForm(par)
								]
							}
						]
					}
				]
			})
		}
	},
	mkE.Base
)